<template>
  <div class="d-flex flex-column h-100">
    <case-back-div
      v-if="false"
      :to="backTo"
    />
    <route-breadcrumb />
    <div class="vu-toolbar">
      <div
        class="vu-toolbar-item"
        :class="{ active: currentTab === 'transcript' }"
        @click="navigateToTranscript"
      >
        <file-text-icon size="1x" class="vu-toolbar-icon"/>
        <span class="vu-toolbar-text">Transcript</span>
      </div>
      <div
        v-if="!hideTranslationTab"
        class="vu-toolbar-item"
        :class="{ active: currentTab === 'translation' }"
        @click="navigateToTranslation"
      >
        <file-plus-icon size="1x" class="vu-toolbar-icon" />
        <span class="vu-toolbar-text">Translation</span>
      </div>
      <div
        class="vu-toolbar-item"
        @click="editMetadata"
      >
        <edit-2-icon size="1x" class="vu-toolbar-icon" />
        <span class="vu-toolbar-text">Profile</span>
      </div>
      <div
        class="vu-toolbar-item"
        @click="() => showExportModal()"
      >
        <download-icon size="1x" class="vu-toolbar-icon" />
        <span class="vu-toolbar-text">Export</span>
      </div>
      <div class="vu-audit-item">
        <span
          class="vu-toolbar-text"
        >
          Show Audit Info
        </span>
        <base-switch
          v-model="showChangeReq"
          style="margin: 0"
          type="primary"
          @input="toggleMode"
        />
      </div>
    </div>
    <div class="d-flex main-height-calc">
      <add-note
        ref="addNoteForm"
        header="Add New Note"
        :upload-id="uploadId"
      />
      <metadata-form-modal
        ref="metadataForm"
      />
      <router-view
        v-if="!clickedView"
        ref="routerView"
      />
      <div
        v-else
        class="flex-grow-1"
      >
        <notes />
      </div>
      <download-blob
        ref="dlblob"
        :blob="dlFileBlob"
        :file-name="dlFileName"
        :content-type="dlFileContentType"
        :visible="false"
      />
      <transcript-export-modal
        ref="exportModal"
        @export="handleExport"
      />
      <message-box
        ref="translationMessage"
        text="The translation feature is disabled for your installation. Please contact ETHOS about enabling it."
        :show="showMessageBox"
        @closeClicked="showMessageBox = false"
      />
    </div>
  </div>
</template>

<script>

import {TabPane, Tabs, BaseSwitch} from "src/components";
import MessageBox from "src/components/MessageBox.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {getUploadById, downloadUpload, getClip, downloadClip} from "../../../api";
import {isDefined} from "../../../api/helpers";
import {ethosRouteNames} from "../../../routes/routeNames";
import Notes from "../Notes/Notes.vue";
import AddNote from "../Notes/AddNote/AddNote.vue";
import MetadataFormModal from "./MetadataFormModal.vue";
import DownloadBlob from "../../Ethos/DownloadBlob.vue";
import {DownloadIcon, FileTextIcon, FilePlusIcon, ScissorsIcon, BriefcaseIcon, LoaderIcon, Edit2Icon} from "vue-feather-icons";
import {downloadUploadTranscript, downloadClipTranscript, ExportType} from "../../../util/exportUtil";
import TranscriptExportModal from "../../../components/DashboardV2/Case/TranscriptExportModal.vue";
import "src/assets/sass/custom/paginated-table.scss";
import {storeRecentCaseUploads} from "../../../util/util";
import CaseBackDiv from "../../../components/DashboardV2/Case/CaseBackDiv.vue";

// Test
// import PresentationView from "src/pages/Ethos/Uploads/ViewUploads/PresentationView/PresentationView.vue";
export default {
  name: "view-uploads",
  components: {
    Tabs,
    BaseSwitch,
    MessageBox,
    TabPane,
    Notes,
    AddNote,
    DownloadBlob,
    ScissorsIcon,
    BriefcaseIcon,
    FileTextIcon,
    FilePlusIcon,
    DownloadIcon,
    LoaderIcon,
    Edit2Icon,
    CaseBackDiv,
    MetadataFormModal,
    TranscriptExportModal,
    // PresentationView,
  },
  data() {
    return {
      upload: null,
      currentTab: "transcript",
      lastMenuItemClicked: null,
      clickedView: false,
      dlFileBlob: null,
      dlFileName: null,
      dlFileContentType: null,
      dloading: false,
      isTranscriptDisplayed: false,
      isClipDisplayed: false,
      showChangeReq: false,
      backButtonTo: null,
      filterTerm: null,
      hideTranslationTab: false,
      showMessageBox: false,
      dialogMessage: "",
    };
  },
  watch: {
    // NOTE: The watch on $route may never be firing
    $route: {
      handler(n, o) {
        this.checkTranscriptDisplayed();
      },
    },
    uploadId: {
      handler(n, o) {
        if (isDefined(n) && (!isDefined(o) || n !== o)) this.loadUpload();
      },
      immediate: true,
    },
    hasSignedUrl(to, from) {
      if (to && !from) {
        this.$nextTick(this.bindRefs);
      }
    },
    showUploadsPopover: {
      immediate: true,
      handler(to, from) {
        this.showChangeReq = to;
      },
    },
  },
  computed: {
    ...mapGetters("data", [
      "displayNotes",
      "displayIncidents",
      "getUploads",
      "showUploadsPopover",
      "getActorMap",
      "getUserMap",
    ]),
    caseId() { // TODO: - Make a mixin for this
      const id = this.$route.params.caseId;
      return isDefined(id) ? parseInt(id, 10) : null;
    },
    uploadId() {
      const id = this.$route.params.uploadId;
      return isDefined(id) ? parseInt(id, 10) : null;
    },
    clipId() {
      const id = this.$route.params.clipId;
      return isDefined(id) ? parseInt(id, 10) : null;
    },
    noteId() {
      const id = this.$route.params.noteId;
      return isDefined(id) ? parseInt(id, 10) : null;
    },
    backTo() {
      return ethosRouteNames.CaseUploads;
    },
    pathPrefix() {
      return `/v2/case/${this.caseId}/view-uploads/${this.uploadId}`;
    },
    shouldShowExportTabs() {
      return (this.isTranscriptDisplayed || this.isClipDisplayed) &&
        !this.clickedView;
    },
  },
  mounted() {
    this.filterTerm = this.$route.query.filterTerm;
    storeRecentCaseUploads(this.caseId, this.uploadId);
    if (this.$route.name === ethosRouteNames.Translation) {
      this.displayTranslation();
    } else if (this.$route.name === ethosRouteNames.TranscriptV2) {
      this.displayTranscript();
    } else if (this.$route.name === ethosRouteNames.ClipV2) {
      this.displayClip();
    }
  },
  methods: {
    ...mapMutations("data", [
      "setBreadcrumbHint",
      "putUpload",
      "toggleUploadsPopover",
    ]),
    ...mapActions("data", [
      "loadPeople",
    ]),
    ...mapGetters("data", [
      "translationIsActive",
    ]),
    loadUpload() {
      this.dlFileBlob = null;
      this.dlFileName = null;
      this.dlFileContentType = null;
      this.upload = null;
      getUploadById(this.uploadId, true).then((e) => {
        this.upload = e;
        this.putUpload(e);
        this.setBreadcrumbHint({name: ethosRouteNames.CaseViewUploads, value: e.name});
      }).catch((ex) => {
        this.$notifyError("Failed to find upload", ex);
      });
    },
    displayTranscript() {
      this.currentTab = "transcript";
      this.isTranscriptDisplayed = true;
      this.isClipDisplayed = false;
      this.hideTranslationTab = false;
      let newPath = `${this.pathPrefix}/transcript`;
      if (this.$route.path === newPath) return;
      newPath = `${newPath}?filterTerm=${this.filterTerm}`;
      this.$router.push(newPath);
    },
    displayTranslation() {
      this.currentTab = "translation";
      this.isTranscriptDisplayed = true;
      this.isClipDisplayed = false;
      this.hideTranslationTab = false;
      let newPath = `${this.pathPrefix}/translation`;
      if (this.$route.path === newPath) return;
      newPath = `${newPath}?filterTerm=${this.filterTerm}`;
      this.$router.push(newPath);
    },
    displayClip() {
      this.currentTab = "transcript";
      this.isTranscriptDisplayed = true;
      this.hideTranslationTab = true;
      this.isClipDisplayed = true;
    },
    menuSelected(x) {
      if (x === "3-1") {
        this.$refs.noteMenu.activeIndex = this.lastMenuItemClicked;
        return;
      }
      this.lastMenuItemClicked = x;
    },
    added() {
      this.$refs.addNoteForm.display();
    },
    viewed() {
      this.clickedView = true;
    },
    navigateToTranscript() {
      this.currentTab = "transcript";
      this.routeTo("transcript");
    },
    navigateToTranslation() {
      if (this.translationIsActive()) {
        this.currentTab = "translation";
        this.routeTo("translation");
      } else {
        this.dialogMessage = "The translation feature is disabled for your installation. Please contact ETHOS about enabling it.";
        this.showMessageBox = true;
      }
    },
    routeTo(id) {
      const prefix = this.pathPrefix;
      const validSuffix = [
        "transcript",
        "clips",
        "translation",
      ];
      if (!validSuffix.includes(id)) return;
      let fullPath = `${prefix}/${id}`;
      if (this.$route && this.$route.path.startsWith(prefix) && this.$route.path !== fullPath) {
        fullPath = `${fullPath}?filterTerm=${this.filterTerm}`;
        this.$router.push(fullPath);
      }
    },
    checkTranscriptDisplayed() {
      const isTranscript = this.$route?.path?.endsWith("transcript");
      const isClip = this.endsWithWildcard(this.$route?.path, "clips/*");
      this.isTranscriptDisplayed = isTranscript;
      this.isClipDisplayed = isClip;
      this.hideTranslationTab = isClip;
    },
    endsWithWildcard(str, pattern) {
      const regexPattern = pattern.replace("*", ".*") + "$";
      const regex = new RegExp(regexPattern);
      return regex.test(str);
    },
    editMetadata(e) {
      const upload = this.getUploads[this.uploadId];
      if (this.isClipDisplayed && isDefined(this.$refs.routerView?.clipId)) {
        this.$refs.routerView?.editMetadata(e);
      } else {
        this.$refs.metadataForm && this.$refs.metadataForm.display(upload);
      }
    },
    toggleMode(type) {
      this.toggleUploadsPopover(this.showChangeReq);
    },
    findTabById(id) {
      return this.$refs.tabs.tabs.find((x) => x._props["id"] === id);
    },
    showExportModal() {
      console.log("showExportModal route name =", this.$route.name);
      console.log("showExportModal upload =", this.upload);
      const showTranslationTab = this.$route.name !== ethosRouteNames.ClipV2 &&
        this.upload && this.upload.transcription && isDefined(this.upload.transcription.translationContent);
      const initialTab = this.$route.name === ethosRouteNames.Translation && showTranslationTab ? "translation" : "transcript";
      this.$refs.exportModal.display(showTranslationTab, initialTab);
    },
    handleExport(data) {
      this.loadPeople().then(() => {
        if (data.type === ExportType.audio) {
          if (isDefined(this.clipId)) {
            console.log("ViewUpload downloadClipOriginal", this.uploadId, this.clipId);
            this.downloadClipOriginal(this.uploadId, this.clipId);
          } else {
            this.downloadOriginal(this.uploadId);
          }
        } else {
          if (isDefined(this.clipId)) {
            this.downloadClipTrans(this.uploadId, this.clipId, data.type, data.withAudio);
          } else {
            this.downloadTranscript(this.uploadId, data.type, data.withAudio);
          }
        }
      });
    },
    downloadTranscript(uploadId, type, withAudio) {
      if (this.dloading) return;
      this.dloading = true;
      downloadUploadTranscript(
        this.loadPeople,
        getUploadById, downloadUpload,
        this.getUserMap, this.getActorMap,
        uploadId, type, withAudio
      )
        .catch((ex) => {
          this.$notifyError("Unable to download file", ex);
        })
        .finally(() => {
          this.dloading = false;
        });
    },
    downloadClipTrans(uploadId, clipId, type, withAudio) {
      if (this.dloading) return;
      this.dloading = true;
      downloadClipTranscript(
        this.loadPeople, getClip, downloadClip, getUploadById,
        this.getUserMap, this.getActorMap,
        uploadId, clipId, type, withAudio
      )
        .catch((ex) => {
          this.$notifyError("Unable to download file", ex);
        })
        .finally(() => {
          this.dloading = false;
        });
    },
    downloadOriginal(uploadId) {
      if (this.dloading) return;
      this.dloading = true;
      getUploadById(uploadId).then((upload) => {
        this.dlFileName = upload.originalFileName;
        this.dlFileContentType = upload.originalFileContentType;
        return downloadUpload(uploadId, true); // TRUE for original
      }).then((blob) => {
        this.dlFileBlob = blob;
        this.$nextTick(() => {
          this.$notifySuccess("Downloading to file");
          this.$refs.dlblob.directDownload();
        });
      }).catch((ex) => {
        this.$notifyError("Unable to download file", ex);
      }).finally(() => {
        this.dloading = false;
      });
    },
    downloadClipOriginal(uploadId, clipId) {
      if (this.dloading) return;
      console.log("downloadClipOriginal going in");
      this.dloading = true;
      getClip(uploadId, clipId).then((clip) => {
        console.log("downloadClipOriginal got clip", clip);
        this.dlFileName = `Clip-${clip.startOffset}:${clip.endOffset}.wav`;
        this.dlFileContentType = "audio/wav";
        return downloadClip(uploadId, clipId);
      }).then((blob) => {
        console.log("downloadClipOriginal got blob");
        this.dlFileBlob = blob;
        this.$nextTick(() => {
          this.$notifySuccess("Downloading to file");
          this.$refs.dlblob.directDownload();
        });
      }).catch((ex) => {
        this.$notifyError("Unable to download file", ex);
      }).finally(() => {
        console.log("downloadClipOriginal finally");
        this.dloading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.main-height-calc {
  height: calc(100% - 95px) !important;
}
.vu-toolbar {
  height: 40px;
  background-color: #202828;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  padding: 0 0 0 20px;
  // border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.vu-toolbar-item {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  user-select: none;
  // color: #669c1c;
  color: white;
}

.vu-toolbar-item:hover {
  background-color: #dbffff14;
}

.vu-toolbar-item.active {
  background-color: #dbffff29;
}

// .vu-toolbar-item.active:hover {
//   background-color: #337ecc;
// }

.vu-toolbar-icon {
  margin-right: 6px;
  font-size: 16px;
}

.vu-toolbar-text {
  font-size: 14px;
  font-weight: 600;
}

.vu-audit-item {
  cursor: default;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  white-space: nowrap;
  user-select: none;
  // color: #669c1c;
  color: white;
}

.vu-audit-item .vu-toolbar-text {
  margin-right: 8px;
  cursor: default;
}

.vu-audit-item base-switch {
  flex-shrink: 0;
}

</style>
